import { createContext, useContext } from 'react';

import type { ShowcaseAuthError, ShowcaseAuthResponse } from '../hooks/use-showcase-auth';
import type { ShowcaseAlbumData } from '../utils/constants';

/**
 * SSR data for the showcase page, fetched in getServerSideProps.
 * When available, downstream hooks use this as initial state to avoid
 * client-side fetch waterfalls (auth → album data).
 */
export interface ShowcaseSSRData {
  /** Auth response when the auth endpoint returned 200 */
  authData?: ShowcaseAuthResponse;
  /** Auth error when the auth endpoint returned non-200 (password, team privacy, etc.) */
  authError?: ShowcaseAuthError;
  /** Album API data, fetched server-side when auth succeeded (only SHOWCASE_ALBUM_FIELDS). */
  albumData?: ShowcaseAlbumData;
}

export const ShowcaseSSRContext = createContext<ShowcaseSSRData | null>(null);

export function useShowcaseSSR(): ShowcaseSSRData | null {
  return useContext(ShowcaseSSRContext);
}
